(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-toggle-hero"] && !Shopify.designMode) return;
  try {
    
  class ImageToggleHero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.initImageToggle();
      this.initSubscribe();
    }

    initImageToggle() {
      this.toggleButton = this.querySelector('[data-toggle-button]');
      this.frontPane = this.querySelector('[data-pane="front"]');
      this.backPane = this.querySelector('[data-pane="back"]');
      this.toggleLabel = this.querySelector('[data-toggle-label]');

      if (!this.toggleButton || !this.frontPane || !this.backPane || !this.toggleLabel) return;

      this.isBackVisible = false;
      this.toggleButton.addEventListener('click', () => this.toggleImage());
      this.updateState();
    }

    toggleImage() {
      this.isBackVisible = !this.isBackVisible;
      this.updateState();
    }

    updateState() {
      this.frontPane.hidden = this.isBackVisible;
      this.backPane.hidden = !this.isBackVisible;
      this.toggleButton.setAttribute('aria-pressed', this.isBackVisible ? 'true' : 'false');

      const nextLabel = this.isBackVisible
        ? this.toggleButton.dataset.backLabel
        : this.toggleButton.dataset.frontLabel;

      this.toggleLabel.textContent = nextLabel || '';
    }

    initSubscribe() {
      this.subscribeToggle = this.querySelector('[data-subscribe-toggle]');
      this.subscribePanel = this.querySelector('[data-subscribe-panel]');
      this.sellingPlanSelect = this.querySelector('[data-selling-plan-select]');
      this.buyButton = this.querySelector('[data-buy-button]');

      if (this.subscribeToggle && this.subscribePanel) {
        this.subscribeToggle.addEventListener('click', () => this.toggleSubscribePanel());
      }

      // Buy now is always a one-time purchase: drop the selling plan on click,
      // even if the subscription panel happens to be open.
      if (this.buyButton && this.sellingPlanSelect) {
        this.buyButton.addEventListener('click', () => {
          this.sellingPlanSelect.disabled = true;
        });
      }
    }

    toggleSubscribePanel() {
      if (!this.subscribePanel) return;

      const willOpen = this.subscribePanel.hasAttribute('hidden');

      if (willOpen) {
        this.subscribePanel.removeAttribute('hidden');
        this.subscribeToggle.setAttribute('aria-expanded', 'true');
        if (this.sellingPlanSelect) this.sellingPlanSelect.disabled = false;
      } else {
        this.subscribePanel.setAttribute('hidden', '');
        this.subscribeToggle.setAttribute('aria-expanded', 'false');
        if (this.sellingPlanSelect) this.sellingPlanSelect.disabled = true;
      }
    }
  }

  if (!customElements.get('image-toggle-hero')) {
    customElements.define('image-toggle-hero', ImageToggleHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
